/** Dispatched after company primary/secondary logos change in localStorage. */
export const COMPANY_LOGOS_UPDATED_EVENT = 'company-logos-updated';

const FRACTION_SALE_THEME = 'Default_Full_Fraction_Sale';
const FRACTION_SALE_COMPANY_ID = '29E9C4AD-9AF2-4757-A001-AC34690B1A12';
const SPECIAL_SIDEBAR_COMPANY_ID = 'DB69182F-9412-4139-BCF1-E7656AB63099';

export function getStoredCompanyLogos() {
    return {
        primary: localStorage.getItem('primaryLogo') || '',
        secondary: localStorage.getItem('secondaryLogo') || ''
    };
}

/** Same rules as Sidebar `created()` for which logo URL binds to `logoPrimary`. */
export function resolveSidebarLogoPrimary() {
    const { primary, secondary } = getStoredCompanyLogos();
    const adminTheme = localStorage.getItem('adminTheme');
    const themeName = localStorage.getItem('themeName');
    const companyId = String(localStorage.getItem('companyId') || '').toUpperCase();

    if (adminTheme === 'light') {
        return secondary || primary;
    }
    if (themeName === FRACTION_SALE_THEME && companyId === FRACTION_SALE_COMPANY_ID) {
        return secondary || primary;
    }
    return primary || secondary;
}

/** Logo URL shown in sidebar/header `#logoimg` for the current company. */
export function resolveSidebarLogoDisplaySrc(companyId) {
    const cid = String(companyId || localStorage.getItem('companyId') || '').toUpperCase();
    const { secondary } = getStoredCompanyLogos();
    if (cid === SPECIAL_SIDEBAR_COMPANY_ID) {
        return secondary;
    }
    return resolveSidebarLogoPrimary();
}

export function applyCompanyLogosToLocalStorage(primaryLogo, secondaryLogo) {
    if (primaryLogo) {
        localStorage.setItem('primaryLogo', primaryLogo);
    }
    if (secondaryLogo) {
        localStorage.setItem('secondaryLogo', secondaryLogo);
    }
}

export function dispatchCompanyLogosUpdated() {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(COMPANY_LOGOS_UPDATED_EVENT));
    }
}

export function applyLogoImgDomSrc(src) {
    if (!src) {
        return;
    }
    const logoEl = document.getElementById('logoimg');
    if (logoEl) {
        logoEl.src = src;
    }
}
